var exports = {
  "a": "Box__8naLVM",
};

module.exports = exports;
